export default "__VITE_ASSET__Dsinj2HY__"